import { useEffect, useRef } from 'react'

// Declare fbq on window object for TypeScript
declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

// Module-level flag to prevent duplicate pixel initialization across multiple hook instances
let pixelInitialized = false

export function useMetaPixel() {
  const hasTrackedPageView = useRef(false)

  useEffect(() => {
    if (pixelInitialized) return

    // Initialize Meta Pixel
    if (!window.fbq) {
      const n: any = (window.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      })

      if (!window._fbq) window._fbq = n
      n.push = n
      n.loaded = !0
      n.version = '2.0'
      n.queue = []

      const t = document.createElement('script')
      t.async = !0
      t.src = 'https://connect.facebook.net/en_US/fbevents.js'

      const s = document.getElementsByTagName('script')[0]
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s)
      } else {
        document.head.appendChild(t)
      }

      window.fbq('init', '1214908514077752')
    }

    // Track PageView only once
    if (!hasTrackedPageView.current) {
      window.fbq('track', 'PageView')
      hasTrackedPageView.current = true
    }

    pixelInitialized = true
  }, [])

  const trackAddToCart = () => {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        value: 11.99,
        currency: 'USD',
        content_name: 'Método Cero Estrés 2-2-2',
        content_type: 'product',
      })
    }
  }

  return { trackAddToCart }
}
